import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material';
import { DriverService } from '../services/driver.service';
import { Broadcaster } from '../services/broadcast.event';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from '../services/auth.service';
import { UserManageInfo } from '../models/userManageInfo';

declare var require: any;
const swal = require('sweetalert2');

@Component({
  selector: 'app-lista-stampanti-dialog',
  templateUrl: './lista-stampanti-dialog.component.html',
  styleUrls: ['./lista-stampanti-dialog.component.css']
})
export class ListaStampantiDialogComponent implements OnInit {
  public currentUser: UserManageInfo = new UserManageInfo();

  listaStampanti: string[] = ['StampanteTest1', 'StampanteTest2'];
  selected: any = null;
  stampante: string = null;
  constructor(private dialogRef: MatDialogRef<ListaStampantiDialogComponent>, private driverService: DriverService, private toastr: ToastrService, private authService: AuthService) {
    this.authService.UserConnected.subscribe(result => {
      this.currentUser = result;
    });
  }

  back(): void {
    this.dialogRef.close();
  }

  

  selezionaStampante() {
    console.log(this.selected)
  }

  postSetConfigStampante(nomeStampante: string) {
    this.driverService.postSetConfigStampante(nomeStampante, this.currentUser.IdImpianto).subscribe(result => {
      console.log(this.selected)
      this.toastr.success('', 'Stampante configurata', {
        timeOut: 3000,
      });
    }, err => {
      swal("Configurazione stampante", "errore nella configurazione della stampante", "error");
    });
  }

  //sendCreditsQuantityConditions() {
  //  if (this.crediti == null)
  //    return true;
  //  if (this.crediti < 0)
  //    return true;
  //  return false;
  //}

  ngOnInit(): void {
    //this.getListaStampanti();
  }

}



// WEBPACK FOOTER //
// ./src/app/lista-stampanti-dialog/lista-stampanti-dialog.component.ts